import React from "react";
export default function Section({ title, subtitle, actions, children, className = "", }: {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
}): any {
    return (<section className={`rounded-card border border-border bg-surface/40 p-4 space-y-4 ${className}`}>
      {(title || subtitle || actions) && (<header className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div>
            {title ? <h2 className="text-sm font-semibold text-fg">{title}</h2> : null}
            {subtitle ? <p className="mt-0.5 text-xs text-fg-subtle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </header>)}
      {children}
    </section>);
}
